import { render, staticRenderFns } from "./CouponDetail.vue?vue&type=template&id=6066d53e&scoped=true"
import script from "./CouponDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponDetail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066d53e",
  null
  
)

export default component.exports